import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InvoiceStatus } from '@spike/commission-model';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './InvoiceStatusBadge.module.scss';

interface InvoiceStatusBadgeProps {
    status?: InvoiceStatus;
    className?: string;
}

const VARIANT_CONFIG: Record<InvoiceStatus, { label: string; className: string; icon?: typeof faCheck }> = {
    'paid': { label: 'Paid', className: styles.paid, icon: faCheck },
    'partially paid': { label: 'Partially Paid', className: styles.partiallyPaid },
    'unpaid': { label: 'Unpaid', className: styles.unpaid },
    'overpaid': { label: 'Overpaid', className: styles.overpaid },
    'void': { label: 'Voided', className: styles.voided }
};

export const InvoiceStatusBadge: FunctionComponent<InvoiceStatusBadgeProps> = ({ status, className }) => {
    if (!status || !(status in VARIANT_CONFIG)) {
        return null;
    }

    const { label, className: variantClassName, icon } = VARIANT_CONFIG[status];

    return (
        <span className={clsx(styles.chip, variantClassName, className)}>
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className={styles.icon}
                />
            )}
            {label}
        </span>
    );
};

export default InvoiceStatusBadge;
